import React from 'react';
import T from './theme';
import CollapsibleCard from './CollapsibleCard';
import { formatPace } from './utils';

export default function PaceBandsCard({ trainingBands, todayBands }) {
  return (
    <CollapsibleCard title="Today's pace bands" accentColor={T.color.accentPace}>
      {trainingBands?.easy_pace_display && (
        <p style={{ color: T.color.textMuted, marginTop: 0 }}>
          From easy {trainingBands.easy_pace_display}
          {['easy_runs', 'all_runs', 'recent_runs', 'gap_hr'].includes(trainingBands.easy_pace_source)
            ? ' (estimated from recent runs)'
            : ''}
          . Adjusted for today's weather.
        </p>
      )}
      {todayBands.length > 0 ? (
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <tbody>
            {todayBands.map((band) => (
              <tr key={band.name}>
                <td style={{ padding: '6px 8px 6px 0' }}>{band.name}</td>
                <td style={{ padding: '6px 0', fontVariantNumeric: 'tabular-nums' }}>
                  {formatPace(band.low)}–{formatPace(band.high)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No weather-adjusted paces yet.</p>
      )}
    </CollapsibleCard>
  );
}
